export default function MessageText({
  color = '#9B9DA2',
  width = '19',
  height = '19',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.31189 13.875H6.99939C4.49939 13.875 3.24939 13.25 3.24939 10.125V7C3.24939 4.5 4.49939 3.25 6.99939 3.25H11.9994C14.4994 3.25 15.7494 4.5 15.7494 7V10.125C15.7494 12.625 14.4994 13.875 11.9994 13.875H11.6869C11.4931 13.875 11.3056 13.9687 11.1869 14.125L10.2494 15.375C9.83689 15.925 9.16189 15.925 8.74939 15.375L7.81189 14.125C7.71189 13.9875 7.48064 13.875 7.31189 13.875Z'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6.37561 7H12.6256'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6.37561 10.125H10.1256'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
